export interface StrategyRule {
  id: string
  label: string
  title: string
  meta: string
  description: string
}

export const strategyRules: StrategyRule[] = [
  {
    id: '01',
    label: 'Rule 01',
    title: 'El Rango',
    meta: '15M',
    description:
      'Marcamos el campo de batalla institucional. El rango de apertura define dónde se posiciona el dinero grande antes de cualquier movimiento.',
  },
  {
    id: '02',
    label: 'Rule 02',
    title: 'El Gatillo',
    meta: '1M',
    description:
      'Esperamos la ruptura sólida y el retroceso técnico. Sin retroceso confirmado, no hay entrada: la paciencia es parte del sistema.',
  },
  {
    id: '03',
    label: 'Rule 03',
    title: 'Gestión 1:2',
    meta: 'R:R',
    description:
      'Stop Loss fijo de 5 pips y objetivo al doble del riesgo. Matemática diseñada para Fondos de Inversión, no para la intuición.',
  },
]

export interface PropFirm {
  name: string
  note: string
}

export const propFirms: PropFirm[] = [
  { name: 'FTMO', note: 'Evaluación 2 fases' },
  { name: 'Topstep', note: 'Futuros / Índices' },
  { name: 'MyFundedFX', note: 'Drawdown estático' },
]

export const offerIncludes: string[] = [
  'Manual PDF — Protocolo de Apertura VIP',
  'Calculadora de Riesgo (lotaje y 5 pips)',
  'Checklist de Sesión pre-mercado',
]
